module.exports = __webpack_public_path__ + "static/media/shopee_logo.5b2f18a9.png";